import { Auth0Provider } from "@auth0/auth0-react";
import { auth0Config, isAuth0Enabled } from "./auth0Config";

function AuthProvider({ children }) {
  if (!isAuth0Enabled) return children;

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        audience: auth0Config.audience,
        redirect_uri: window.location.origin,
        scope: "openid profile email"
      }}
      cacheLocation="localstorage"
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  );
}

export default AuthProvider;
